<template>
    <!-- 未完成部分 导出功能 列表操作删除功能 详情信息上传附件功能 附件展示接口 -->
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="客户名称">
                    <el-input v-model="credit_customer_name" placeholder="" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCreditCustomerBlacklists(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                受限名单列表
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span>导出全部</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table :data="userList" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Blacklist_ID" label="ID" width="100" align="center"></el-table-column>
                <el-table-column prop="Credit_Customer_Name" label="客户名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Credit_Customer_Code" label="客户编号" align="center"></el-table-column>
                <el-table-column prop="Credit_Customer_UniformCode" label="统一编号" align="center"></el-table-column>
                <el-table-column prop="Blacklist_StateName" label="状态" align="center"></el-table-column>
                <el-table-column prop="Blacklist_Addtime" label="添加时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleDetail(scope.row)">查看</span>
                            <span class="operation-bar-block operation-bar-block-del" @click="handledelete(scope.row)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="黑名单详情" :visible.sync="isDrawer" width="1200px" :before-close="handleClose" :close-on-click-modal="false">
            <div class="payment">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户名称：</div>
                            <div>{{ details.Credit_Customer_Name }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户编号：</div>
                            <div>
                                {{ details.Credit_Customer_Code }}
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">统一编号：</div>
                            <div>
                                {{ details.Credit_Customer_UniformCode }}
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">添加时间：</div>
                            <div>{{ details.Blacklist_Addtime }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">状态：</div>
                            <div>
                                <el-radio v-model="details.Blacklist_State" label="1">受限</el-radio>
                                <el-radio v-model="details.Blacklist_State" label="0">不受限</el-radio>
                                <el-button type="primary" @click="getEditCreditCustomerBlacklist()">更改状态</el-button>
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">附件上传：</div>
                            <Hwupload ref="Hwupload">
                                <template v-slot:after-upload-button>
                                    <!-- 这里是你想在上传按钮后面显示的内容 -->
                                    <el-button style="margin-left: 10px" type="primary" @click="getUpdateBlackListFile()">保存附件</el-button>
                                </template>
                            </Hwupload>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">附件：</div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">变更日志：</div>
                            <div>
                                <el-table :data="tableData" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" show-overflow-tooltip align="center"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="备注" align="center"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">附件列表：</div>
                            <div>
                                <el-table :data="filelogList" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" align="center"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="附件" align="center">
                                        <template slot-scope="scope">
                                            <div class="operation-bar">
                                                <span class="operation-bar-block" @click="downFile(scope.row.Remarks)">打开</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import Hwupload from '@/components/Hwupload/index.vue';
import { myMixin } from '@/utils/mixin.js';
export default {
    name: 'blacklist',
    mixins: [myMixin],
    components: {
        Pagination,
        Hwupload
    },
    data() {
        return {
            credit_customer_name: '',
            loadingBtn: false,
            isDrawer: false,
            details: {
                Blacklist_ID: '',
                Credit_Customer_Name: '',
                Credit_Customer_Code: '',
                Credit_Customer_UniformCode: '',
                Blacklist_Addtime: '',
                Blacklist_State: '',
                Blacklist_StateName: '',
                ChangeBlacklist_State: '',
                UploadState: ''
            },
            userList: [],
            tableData: [],
            filelogList: []
        };
    },
    mounted() {
        this.getCreditCustomerBlacklists();
    },
    methods: {
        onRefresh() {
            this.credit_customer_name = '';
            this.getCreditCustomerBlacklists(true);
        },
        /*
  获取列表
 */
        getCreditCustomerBlacklists(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            let params = {
                Page: this.paginationOptions.Page,
                PageSize: this.paginationOptions.PageSize,
                json: JSON.stringify({ credit_customer_name: this.credit_customer_name })
            };
            this.$newsApi
                .getCreditCustomerBlacklists(params)
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.userList = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.userList = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
    获取详情信息
   */
        getCreditCustomerBlacklistByID(id) {
            this.$newsApi.getCreditCustomerBlacklistByID({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    if (res.data.data && res.data.data.length > 0) {
                        this.details = res.data.data[0];
                    }
                }
            });
            this.getCreditCustomerBlackLogs(id);
            this.getCreditCustomerBlackAttachments(id);
        },
        /*
     获取日志
    */
        getCreditCustomerBlackLogs(id) {
            this.$newsApi.getCreditCustomerBlackLogs({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.tableData = res.data.data;
                }
            });
        },
        /*
     获取附件
    */
        getCreditCustomerBlackAttachments(id) {
            this.$newsApi.getCreditCustomerBlackAttachments({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.filelogList = res.data.data;
                }
            });
        },
        downFile(file) {
            window.open(file);
        },
        /*
    变更受限状态
   */
        getEditCreditCustomerBlacklist() {
            const id = this.details.Blacklist_ID;
            const status = Number(this.details.Blacklist_State);
            this.$newsApi.getEditCreditCustomerBlacklist({ id, status }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            // 这里是提示关闭后的回调函数
                            this.getCreditCustomerBlacklistByID(id);
                        }
                    });
                }
            });
        },
        /*
    保存附件
   */
        getUpdateBlackListFile() {
            const id = this.details.Blacklist_ID;
            const remarks = this.$refs.Hwupload.filePath;
            this.$newsApi.getUpdateBlackListFile({ id, remarks }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        type: 'success',
                        message: '操作成功',
                        onClose: () => {
                            this.getCreditCustomerBlackAttachments(this.details.Blacklist_ID);
                            // 这里是提示关闭后的回调函数
                        }
                    });
                }
            });
        },
        handleClose() {
            this.isDrawer = false;
        },
        handledelete(row) {
            this.$confirm('记录删除后将无法恢复，您确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$newsApi.getDelCreditCustomerBlacklist({ id: row.Blacklist_ID }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                                onClose: () => {
                                    // 这里是提示关闭后的回调函数
                                    this.onRefresh();
                                }
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        handleDetail(row) {
            this.isDrawer = true;
            this.getCreditCustomerBlacklistByID(row.Blacklist_ID);
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getCreditCustomerBlacklists();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getCreditCustomerBlacklists();
        }
    }
};
</script>

<style lang="scss" scoped>
.required {
    color: red;
    margin-left: 4px;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
</style>
